// This file is used when building with `ng build --configuration=stage`

export const environment = {
  production: false,
  apiUrl: "https://erp-ca-bmfp-agent-stage-api.ss.frontlineeducation.com",
};
